import {
  slideInMenuPrefix,
  slideInMenuPrefixWithHash,
} from './SlideInMenu.config';

export function createSlideInMenuAnchorLink(atOneBasedIndex = 1) {
  return `${slideInMenuPrefix}-${atOneBasedIndex}`;
}

export function computeSlideInMenuState(urlFragmentWithHash: string) {
  const isOpen =
    !!urlFragmentWithHash &&
    urlFragmentWithHash.startsWith(slideInMenuPrefixWithHash);

  let currentTab = 0;

  if (isOpen) {
    // For ease of use for non programmers we use 1-based index,
    // '0' is deemed invalid.
    currentTab =
      parseInt(
        urlFragmentWithHash.slice(slideInMenuPrefixWithHash.length + 1),
        10,
      ) || 0;
  }

  return {
    isOpen,
    currentTab,
  };
}
